import Cards from './cards.vue';

export default Cards;
